import React from 'react';

import { StyleSheet } from 'react-native';

import { IBackendCartEntries } from '@rbi-ctg/menu';
import Currency from 'components/currency';
import { Box, Typography } from 'components/ui';
import { useComposeDescription } from 'hooks/use-compose-description';
import { spacing } from 'styles/constants';
import { getDesignToken } from 'styles/constants';
import { CartEntryType } from 'utils/cart/types';
import priceForCartEntry from 'utils/menu/price-for-cart-entry';

interface ILegacyCartEntry {
  entry: IBackendCartEntries;
  currencyFormatter: Function;
  index?: number;
}

const CartEntry = ({ entry, currencyFormatter }: ILegacyCartEntry) => {
  const quantity = entry.quantity || 1;
  const amount = priceForCartEntry(entry);
  const cartEntryDescription = useComposeDescription(entry, { includeModifiers: true });
  const isOfferDiscount = entry.type === CartEntryType.offerDiscount;
  const shouldShowPrice = entry.price !== null && !isOfferDiscount;

  return (
    <Box style={styles.item} accessible focusable>
      <Box style={styles.itemHeader}>
        <Typography variant="headerFour" style={styles.itemName}>
          {quantity > 1 && `${quantity}x `}
          {entry.name}
        </Typography>
        <Box style={styles.itemPrice}>
          {shouldShowPrice && (
            <Currency
              amount={amount}
              textProps={{
                ...(amount === 0 && { color: getDesignToken('icon-default') }),
                variant: 'headerFour',
                style: { margin: 0 },
                textAlign: 'right',
              }}
            />
          )}
        </Box>
      </Box>

      {cartEntryDescription?.length > 0 &&
        cartEntryDescription.map((descriptionItem, index) => (
          <Typography
            variant="copyTwo"
            style={styles.entryDescriptionRow}
            key={`descriptionItem-${index}`}
          >
            {descriptionItem}
          </Typography>
        ))}
    </Box>
  );
};

export default CartEntry;

const styles = StyleSheet.create({
  entryDescriptionRow: {
    margin: 0,
    width: '100%',
  },
  item: {
    alignItems: 'baseline',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginBottom: spacing.$1,
    padding: 0,
  },
  itemHeader: {
    alignItems: 'flex-start',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: spacing.$1,
    width: '100%',
  },
  itemName: {
    flexBasis: '80%',
    flexShrink: 1,
    margin: 0,
  },
  itemPrice: {
    alignItems: 'flex-end',
    flexGrow: 0,
    flexShrink: 0,
    justifyContent: 'center',
    width: '16.666%',
  },
});
